import { URL_KEYS } from './urlParams';

// A link to the orders table pre-filtered to the given status(es). Built from
// URL_KEYS so it stays in sync with what the table reads back.
export const ordersPathForStatus = (...statuses: string[]): string => {
  const params = new URLSearchParams();
  statuses.filter(Boolean).forEach((status) => params.append(URL_KEYS.status, status));
  const query = params.toString();
  return query ? `/orders?${query}` : '/orders';
};
